export const OBJECT_NAME = 'mle_object';
export const TRANSFORMER_NAME = 'transformer';
export const GUIDELINE_NAME = 'guideline';
